export enum Breakpoints {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
  LARGE_DESKTOP = 'LARGE_DESKTOP',
}

export type Breakpoint = keyof typeof Breakpoints;

class MobileUtilityService {
  isTouchDevice = 'ontouchstart' in window && !('msMaxTouchPoints' in navigator) && !navigator.userAgent.toLowerCase().match(/windows phone os 7/i); // jshint ignore:line

  private _breakpoint: Breakpoint = Breakpoints.MOBILE;
  private viewportChangedListeners: ((breakpoint: Breakpoint) => void)[] = [];

  constructor() {
    this.registerMatchMediaListeners();
  }

  addViewportChangedListener(listener: (breakpoint: Breakpoint) => void) {
    this.viewportChangedListeners.push(listener);
    this.callListeners([listener]);
    return () => {
      this.viewportChangedListeners = this.viewportChangedListeners.filter(_listener => _listener !== listener);
    };
  }

  removeViewportChangedListener(listener: (breakpoint: Breakpoint) => void) {
    this.viewportChangedListeners = this.viewportChangedListeners.filter(_listener => _listener !== listener);
  }

  get breakpoint(): Breakpoint {
    return this._breakpoint;
  }

  private callListeners(listeners: ((breakpoint: Breakpoint) => void)[]) {
    listeners.forEach(listener => listener.apply(null, [this._breakpoint]));
  }

  private registerMatchMediaListeners() {
    const mediaQueries = {
      [Breakpoints.MOBILE]: '(max-width: 767px)',
      [Breakpoints.TABLET]: '(min-width: 768px) and (max-width: 991px)',
      [Breakpoints.DESKTOP]: '(min-width: 992px) and (max-width: 1199px)',
      [Breakpoints.LARGE_DESKTOP]: '(min-width: 1200px)',
    };

    Object.keys(mediaQueries).forEach((breakpoint: string) => {
      const matchMedia = window.matchMedia(mediaQueries[breakpoint as Breakpoint]);
      if (typeof matchMedia.addListener !== 'function') {
        return;
      }
      matchMedia.addListener(() => {
        if (matchMedia.matches) {
          this._breakpoint = breakpoint as Breakpoint;
          this.callListeners(this.viewportChangedListeners);
        }
        return;
      });
      if (matchMedia.matches) {
        this._breakpoint = breakpoint as Breakpoint;
      }
    });
  }
}

export const MobileUtility = new MobileUtilityService();
